module.exports = {
    public:'公共设置',
    module:'模块设置',
    scription:'订阅',
    helpcenter:'帮助中心',
    resource:'资源',
    task:'任务提醒',
    productUpdate:'产品更新',
    contract:'合同到期提醒',
    invoice:'账单提醒',
    week:'每周一次',
    month:'每月一次',
    day:'每天一次',
    report:'报表',
    creative:'素材',
    closing:'结案报告',
    analysis:'分析报告',
    fixsuccess:'修改成功',
    fixfail:'修改失败',
    Notopen:'未开通',
    ServiceTeam:'服务团队',
    koltrack:'网红流程',
}


// WEBPACK FOOTER //
// ./src/i18n/modules/notificationSub/zh-cn.js